import React from "react";
import { CgSpinnerTwo } from "react-icons/cg";

interface AppSpinnerProps {
  className?: string;
}

const AppSpinner: React.FC<AppSpinnerProps> = ({ className }) => {
  return (
    <div className={`spinner ${className}`}>
      <CgSpinnerTwo className="animate-spin h-5 w-5 text-yellow-700" />
    </div>
  );
};

export default AppSpinner;
